export async function filterAsync<T>(
    arr: T[],
    promiser: (val: T) => Promise<boolean>,
): Promise<T[]> {
    const arrayOrig = arr;

    const newArray: T[] = [];

    for (const val of arrayOrig) {
        const shouldAdd = await promiser(val);
        if (shouldAdd) {
            newArray.push(val);
        }
    }

    return newArray;
}

export default Object.freeze({
    filterAsync,
});
